const route = {
	path: ':subsidiaryId/:subsidiaryName/accounting-periods',
	name: 'accounting-periods',
	meta: {
		title: 'Periodos Contables',
	},
	component: () => import('@/pages/accounting-periods/page-accounting-period'),
	props: true,
	children: [
		{
			name: 'accounting-period-edit',
			path: ':id/edit',
			meta: {
				title: 'Editar Periodo Contable',
			},
			component: () => import('@/pages/accounting-periods/page-accounting-period-edit'),
			props: true,
		},
		{
			name: 'accounting-period-lock',
			path: ':id/lock',
			meta: {
				title: 'Bloquear Periodo Contable',
			},
			component: () => import('@/pages/accounting-periods/page-accounting-period-lock'),
			props: true,
		},
		{
			name: 'accounting-period-activate',
			path: ':code',
			meta: {
				title: 'Activar Periodo Contable',
			},
			component: () => import('@/pages/accounting-periods/page-accounting-period-activate'),
			props: true,
		},
	],
};

export default route;



// WEBPACK FOOTER //
// ./src/router/accounting-periods.js